import React from "react"
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import ApiService from "../../../Services/ApiService";
import AlertService from "../../../Services/AlertService";

class ImageDropzone extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            campaign_id: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.campaignID !== '') {
            this.setState({...this.state,
                campaign_id: nextProps.campaignID,
            });
        }
    }

    handleSubmit(files) {
        let imageFiles = [];

        for (let i=0; i < files.length; i++) {
            let file = files[i].file;
            imageFiles.push(file);
        }

        ApiService.post('/api/campaigns/upload-campaign-ad-images', {
            campaign_id: this.state.campaign_id,
            'images[]': imageFiles
        })
            .then(response => {
                console.log(response.data);
                let successfulCount = response.data.successful.length;
                let message = "Successfully uploaded " + successfulCount + " files.";

                if (response.data.skipped.length > 0) {
                    let skippedFiles = response.data.skipped.join(', ');
                    let skippedCount = response.data.skipped.length;
                    message = message + " Skipped uploading " + skippedCount + " files: " + skippedFiles;
                }

                let dropzoneInfoEl = document.getElementById('dropzone-info');
                dropzoneInfoEl.innerText = message;
                dropzoneInfoEl.style.display = 'block';

                files.forEach(f => f.remove());

            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        return(
            <div>
                <div className="dropzone-container">
                    <Dropzone
                        onSubmit={this.handleSubmit}
                        accept="image/*"
                        inputContent={(files, extra) => (extra.reject ? 'Image files only' : 'Drag and Drop Ad Image Files')}
                        styles={{
                            dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
                            inputLabel: (files, extra) => (extra.reject ? { color: 'red' } : {})
                        }}
                    />
                </div>
                <div id="dropzone-info" className="alert alert-primary">
                </div>
            </div>
        )
    }
}


export default ImageDropzone;